import {makeAutoObservable} from 'mobx';
import LessonsRepository from '../../../data/repositories/LessonsRepository';
import CoursesRepository from '../../../data/repositories/CoursesRepository';
import FoldersRepository from '../../../data/repositories/FoldersRepository';

class CourseLessonEditorStore {
  private lessonRepository = new LessonsRepository();
  private courseRepo = new CoursesRepository();
  private foldersRepo = new FoldersRepository();

  constructor() {
    makeAutoObservable(this);
  }

  public async getLesson(organizationId: string, lessonId: string) {
    const result = await this.lessonRepository.getLessonById(
      organizationId,
      lessonId,
    );
    if (result.success && result.data) {
      return result.data;
    }
  }

  public async getLessonIsPublished(organizationId: string, lessonId: string) {
    const result = await this.lessonRepository.getLessonIsPublishedById(
      organizationId,
      lessonId,
    );
    if (result.success && result.data) {
      return result.data;
    }
  }

  public async getCourse(organizationId: string, courseId: string) {
    const result = await this.courseRepo.getCourse(organizationId, courseId);
    return result.data;
  }

  public async getLessonFolder(organizationId: string, folderId: string) {
    const result = await this.foldersRepo.getFolderById(
      organizationId,
      folderId,
    );

    return result.data;
  }

  public async exportAsScorm(
    organizationId: string,
    courseId: string,
    courseName: string,
  ) {
    await this.courseRepo.exportAsScorm(organizationId, courseId, courseName);
  }
}

export default CourseLessonEditorStore;
